import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../../../utility/ChartTableToggle";
import DailyAnalysis from "./DailyUtilisation/DailyAnalysis";
import MonthAnalysis from "./DailyUtilisation/MonthAnalysis";
import { fetchOptimalUtilisation } from "../../../../../../Rest_api/DemoRestApi";
import AnnualSummaryTable from "../SimulationTable";
import AnnualSummaryScenarioTable from "../SimulationTableComparison";
const DataTabs = ["Volume", "Cost"];

export default function ScenarioComparisonCostAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  selectedTargetDate,
  selectedScenarios,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  selectedTargetDate: any[];
  selectedScenarios: Array<{ scenario_id: number, scenario_number: number }>;
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  // Note: Each child component (DailyAnalysis, MonthAnalysis) fetches its own data
  // No need to fetch data here in the parent component

  return (
    <>
      <div className="load-data grid grid-cols-2 p-2 md:grid-cols-12 grid-rows-full md:grid-rows-[60%_40%] gap-2 h-full w-full md:overflow-hidden rounded-2xl bg-[#F8F9FA]">
        <div className="col-span-1 md:col-span-12 w-full !h-[100%]">
          <div className="flex flex-col md:flex-row gap-2 !h-[100%]">
            <DailyAnalysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              selectedTargetDate={selectedTargetDate}
              selectedScenarios={selectedScenarios}
            />
            <MonthAnalysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              selectedScenarios={selectedScenarios}
            />
          </div>
        </div>
        <AnnualSummaryScenarioTable
          refreshKey={refreshKey}
          setError={setError}
          selectedScenarios={selectedScenarios}
        />
      </div>
    </>
  );
}
